import './UserGroupDropdown.scss';

import React, { useRef } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useThrottledSearchValue } from '../hooks/useThrottledSearchValue';
import { useApim } from '../hooks/useApi';
import { useAppSelector } from '../hooks/ReduxHooks';
import { GoFormzServices } from '../AppSettings';

export interface UserGroupDropdownProps {
  selectedName?: string;
  selectedId?: string;
  onChange?: AnyFunc;
  anyone?: boolean;
  hideUsers?: boolean;
  hideGroups?: boolean;
  hideAdministrator?: boolean;
  hideDeactivatedUsers?: boolean;
  hideCurrentUser?: boolean;
  hidePendingUsers?: boolean;
  loading?: boolean;
  userGroupList?: TypeMePlease;
  groupSelected?: boolean;
}

const printConfigAllPagesValue = 'allpagezasd9gfsai';

export default function UserGroupDropdown(props: UserGroupDropdownProps) {
  const [searchText, searchValue, setSearch] = useThrottledSearchValue('', 500);
  const [currentUserResult, , currentUserLoaded] = useApim<TypeMePlease>(
    GoFormzServices.AccountService,
    `/users/${props.selectedId}`,
    !props.selectedId || !!props.selectedName || props.groupSelected
  );
  const [usersResult, usersLoading, usersLoaded] = useApim<TypeMePlease>(
    GoFormzServices.AccountService,
    `/users/search?q=${encodeURIComponent(searchValue) || ''}&onlyActive=${props.hideDeactivatedUsers ? 'true' : 'false'}&hidePendingUsers=${
      props.hidePendingUsers ? 'true' : 'false'
    }`
  );
  const [groupsResult, groupsLoading, groupsLoaded] = useApim<TypeMePlease>(
    GoFormzServices.AccountService,
    `/groups/search?q=${encodeURIComponent(searchValue) || ''}`
  );
  const users = usersLoaded ? usersResult.users : [];
  const groups = groupsLoaded ? groupsResult.groups : [];
  const dropdown = useRef<TypeMePlease>();
  const currentUser = useAppSelector<string>((state) => state.profile.user.id);

  const onChange = (id, name, type) => {
    dropdown.current.close();
    props.onChange(id, name, type);
    setSearch('');
  };

  let selectedName = props.selectedName || (currentUserLoaded && currentUserResult ? `${currentUserResult.firstName} ${currentUserResult.lastName}` : '');
  const items = [];
  if (props.anyone) {
    items.push(
      <Dropdown.Item
        key="Anyone"
        text="Anyone"
        value={printConfigAllPagesValue}
        selected={!props.selectedId}
        onClick={() => {
          onChange(null, null, 'anyone');
        }}
      />
    );
  }
  if (users && !props.hideUsers) {
    items.push(<Dropdown.Header key="users">USERS</Dropdown.Header>);
    for (const user of users) {
      if (props.selectedId === user.id && !selectedName) {
        selectedName = `${user.firstName} ${user.lastName}`;
      }
      if (props.hideCurrentUser && user.id === currentUser) {
        continue;
      }
      items.push(
        <Dropdown.Item
          key={user.id}
          onClick={() => {
            onChange(user.id, `${user.firstName} ${user.lastName}`, 'user');
          }}
          selected={props.selectedId === user.id}
          description={user.userName}
          text={`${user.firstName} ${user.lastName}`}
        />
      );
    }
  }
  if (groups && !props.hideGroups) {
    items.push(<Dropdown.Header key="groups">GROUPS</Dropdown.Header>);
    for (const group of groups) {
      if (props.selectedId === group.id && !selectedName) {
        selectedName = group.name;
      }

      if (props.hideAdministrator && group.name === 'Administrators') {
        continue;
      }
      items.push(
        <Dropdown.Item
          key={group.id}
          onClick={() => {
            onChange(group.id, group.name, 'group');
          }}
          selected={props.selectedId === group.id}
        >
          {group.name}
        </Dropdown.Item>
      );
    }
  }
  let placeHolderText = '';
  if (!props.hideGroups && !props.hideUsers) {
    placeHolderText = 'Select a user or Group';
  } else if (!props.hideUsers) {
    placeHolderText = 'Select a user';
  } else if (!props.hideGroups) {
    placeHolderText = 'Select a Group';
  }

  let text = null;
  if (props.selectedId) {
    text = selectedName || 'Loading';
  } else if (props.anyone) {
    text = 'Anyone';
  }
  // TODO: Handle selectedId when not in list and selectedName not passed in
  return (
    <Dropdown
      ref={dropdown}
      placeholder={placeHolderText}
      text={text}
      onSearchChange={(e, data) => setSearch(data.searchQuery)}
      fluid
      search
      // selection
      loading={usersLoading || groupsLoading}
      className={text ? 'user-group-dropdown selection' : 'user-group-dropdown placeholder-text selection'}
      searchQuery={searchText}
    >
      <Dropdown.Menu>{items}</Dropdown.Menu>
    </Dropdown>
  );
}
